import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Grid from "@mui/material/Grid";
import HomeIcon from "@mui/icons-material/Home";
import MenuHeader from "../../components/Layout/MenuHeader";
import MenuFooter from "../../components/Layout/MenuFooter";
//https://github.com/mui/material-ui/blob/v5.11.16/docs/data/material/getting-started/templates/dashboard/Dashboard.tsx
const drawerWidth = 300;
import ListCard from "../../components/ListCard";
import MenuTreeView from "./components/MenuTreeView";
import ContentRenderer from "../../components/ContentRenderer";
import FormQuestion from "../../components/FormQuestion";
import RadioButtonTest from "../../components/Tests/RadioButtonTest";
import InputNumberTest from "../../components/Tests/InputNumberTest";
import OverlayLoader from "../../components/OverlayLoader";
import TrueFalseTest from "../../components/Tests/TrueFalseTest";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { showToast } from "../../utils/toast";
import { sanitizeEmailNickname } from "../../utils/generals";
import ChatWidget from "../../components/ChatWidget";

import HttpClient from "../../helpers/HttpClient";

import VocabularyTable from "../../components/Steppers/VocabularyTable";
import ExcerciseContainer from "../../components/Steppers/components/ExcerciseContainer";
import EvaluationReviewContainer from "../../components/Steppers/components/QuizReviewContainer";
import QuizContainer from "../../components/Quiz/QuizContainer";
import ExerciseContainerSR from "../../components/SpeedReading/ExerciseContainerSR";
import TestContainer from "../../components/SpeedReading/TestContainer";

import "./styles.scss";
interface Props {
  window?: () => Window;
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function CourseHome() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openLoader, setOpenLoader] = React.useState(true);
  const [showUnits, setShowUnits] = React.useState(true);
  const [units, setUnits] = React.useState([]);
  const [dataMenu, setDataMenu] = React.useState([]);
  const [htmlContent, setHtmlContent] = React.useState(null);
  const [formData, setFormData] = React.useState(null);
  const [testData, setTestData] = React.useState(null);
  const menuTreeViewRef = React.useRef();
  const authState = useSelector((state) => state.auth);
  const [hasChatWidget, setHasChatWidget] = React.useState(false);
  const [unitData, setUnitData] = React.useState({
    code:0,
    name: ""
  })
  const navigate = useNavigate();
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const [nextNodeId, setNextNodeId] = React.useState(null);
  const { courseCode } = useParams();
  const [isFormFinalize, setIsFormFinalize] = React.useState(false);
  const [isTestFinalize, setIsTestFinalize] = React.useState(false);
  const [isSublessonFinalize, setIsSublessonFinalize] = React.useState(false);
  const [percentage, setPercentage] = React.useState(0);
  const [legalPage, setLegalPage] = React.useState("<div></div>");
  const [course, setCourse] = React.useState(null);
  const [config, setConfig] = React.useState(null);
  const [website, setWebsite] = React.useState("");
  const [botonComunidad, setBotonComunidad] = React.useState("");
  const [botonGames, setBotonGames] = React.useState("");
  const [chatWigetUrl, setChatWigetUrl] = React.useState({
    chatendpoint: "",
    chathistory: ""
  });
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const getPercentage = (data) => {
    const percentages = [];
    let lastUnit = null
    for (let i = 0; i < data.length; i++) {
      if (data[i].viewed == 1) lastUnit = data[i];
      if (data[i].lessons && data[i].lessons.length > 0) {
        for (let j = 0; j < data[i].lessons.length; j++) {
          if (
            data[i].lessons[j].sublessons &&
            data[i].lessons[j].sublessons.length > 0
          ) {
            const ar = data[i].lessons[j].sublessons.filter(
              (ele) => ele.viewed == 1
            );

            if (data[i].viewed == 0 && ar.length > 0) lastUnit = data[i];
            percentages.push(
              (ar.length * 100) / data[i].lessons[j].sublessons.length
            );
          }
          if (data[i].lessons[j].operativa == 1) {
            percentages.push(data[i].lessons[j].viewed == 1 ? 100 : 0);
          }
        }
      }
    }

    if (lastUnit) {
      setUnitData({
        code: extractFinalNumber(lastUnit.cod_unidad),
        name: extractUnitName(lastUnit.nombre)
      })
    } else {
      setUnitData({
        code: 0,
        name: ""
      })
    }
    console.log(percentages);
    const finalPercentage = percentages.reduce((accumulator, value) => {
      return accumulator + value;
    }, 0);
    setPercentage(parseInt(finalPercentage / percentages.length));
  };

  const checkLesson = (lesson) => {
    if (lesson.operativa == 1) return lesson.viewed == 1;
    return (
      lesson.sublessons &&
      Array.isArray(lesson.sublessons) &&
      lesson.sublessons.length > 0 &&
      lesson.sublessons.filter((ele) => ele.viewed == 0).length == 0
    );
  };

  const checkLessonSublessons = (lesson) => {
    return (
      lesson.sublessons &&
      Array.isArray(lesson.sublessons) &&
      lesson.sublessons.length > 0 &&
      lesson.sublessons.some((ele) => ele.viewed == 1).length > 0
    );
  };

  const checkUnit = (unit) => {
    return (
      unit.lessons &&
      Array.isArray(unit.lessons) &&
      unit.lessons.length > 0 &&
      unit.lessons.filter((ele) => ele.viewed == 0).length == 0
    );
  };

  const checkUnitLesson = (unit) => {
    return (
      unit.lessons &&
      Array.isArray(unit.lessons) &&
      unit.lessons.length > 0 &&
      unit.lessons.some((ele) => ele.viewed == 1).length > 0
    );
  };

  const checkUnitLessonSubLessons = (unit) => {

    if (!unit.lessons || unit.lessons?.length == 0) return false

    let isSomeViewed = false
    for (let i = 0; i < units?.lessons?.length; i++) {
      if (checkLessonSublessons(unit.lessons[i])) {
        isSomeViewed = true
        i = units?.lessons?.length;
      }
    }

    return isSomeViewed 
  };

  const extractFinalNumber = (cadena) => {
    const match = cadena.match(/(\d+)$/); 
    if (match) {
      return parseInt(match[1], 10); 
    }
    return 0; 
  }

  const extractUnitName = (titulo) => {
    const match = titulo.match(/-\s*(.+)$/);
    return match ? match[1].trim() : titulo.trim();
  }

  const loadMenu = async () => {
    const userId = authState && authState.user ? authState.user.email : "test";
    //requestHTTP

    //llamado a api
    const request = await HttpClient().get(
      `/courses/course/${userId}/${courseCode}`
    );
    console.log(request);
    if (request.error) {
      setOpenLoader(false);
      showToast(
        "No se pudo cargar información del test. Refresca la página e intenta nuevamente.",
        "error"
      );
      return;
    }

    const courseDataTem = request.data.course;
    setHasChatWidget(request.data.cw)
    console.log(request.data.config);
    setCourse(courseDataTem);
    setConfig(request.data.config);
    const generalTem = await HttpClient().get(`/general`);

    if (courseDataTem) {
      setLegalPage(courseDataTem.paginalegal);
    }

    if (!generalTem.error) {
      setWebsite(generalTem.data.sitioweb);
      setBotonComunidad(generalTem.data.boton_comunidad || "");
      setBotonGames(generalTem.data.boton_games || "");
      setChatWigetUrl({
        chatendpoint: generalTem.data.chatendpoint,
        chathistory: generalTem.data.chathistory
      })
    }

    const units = request.data.units;
    let dataMenu = [];
    let indexUnit = -1

    if (units) {
      dataMenu = units;
      setUnits(units);

      //const request2 =
      const lessonIds = request.data.lessons.map((ele) => ele.cod_leccion);
      const sublessonsRequest = await HttpClient().post(
        `/lessons/sublessons-by-lessons-ids/${userId}`,
        {
          lessonIds: lessonIds.join(","),
        }
      );

      for (let i = 0; i < dataMenu.length; i++) {
        const lessons = request.data.lessons.filter(
          (ele) => ele.cod_unidad == dataMenu[i]["cod_unidad"]
        );
        if (lessons) {
          if (!sublessonsRequest.error) {
            for (let j = 0; j < lessons.length; j++) {
              const sublessons = sublessonsRequest.data.filter(
                (ele) => ele.cod_leccion == lessons[j].cod_leccion
              );
              if (sublessons && sublessons.length) {
                sublessons.map(function (sub) {
                  sub["cod_unidad"] = dataMenu[i].cod_unidad;
                });
                lessons[j]["sublessons"] = sublessons;
                lessons[j]["viewed"] = checkLesson(lessons[j]) ? 1 : 0;
              }
            }
          }
        }

        dataMenu[i]["lessons"] = lessons;
        const isUnitViewed = checkUnit(dataMenu[i]);
        dataMenu[i]["viewed"] = isUnitViewed
        if (isUnitViewed) {
          indexUnit = i
        }
      }
    }

    if (indexUnit == -1) {

      const isSomeLessonViewed = dataMenu[0]["lessons"]?.length == 0 ? false : checkUnitLesson(dataMenu[0])
      const isSomeSubLessonViewed = dataMenu[0]["lessons"]?.length == 0 ? false : checkUnitLessonSubLessons(dataMenu[0])
      if (isSomeLessonViewed || isSomeSubLessonViewed) {
        setUnitData({
          code: extractFinalNumber(dataMenu[0].cod_unidad),
          name: extractUnitName(dataMenu[0].nombre)
        })
      } else {
        setUnitData({
          code: 0,
          name: ""
        })
      }

    }

    if (indexUnit > -1) {

      const nextIndex = indexUnit + 1
      let selectedUnit = undefined
      if (nextIndex > dataMenu.length - 1) {
        selectedUnit = dataMenu[indexUnit]
      } else {
        const nextUnit = dataMenu[nextIndex]
        const isSomeLessonViewed = nextUnit["lessons"]?.length == 0 ? false : checkUnitLesson(nextUnit)
        const isSomeSubLessonViewed = nextUnit["lessons"]?.length == 0 ? false : checkUnitLessonSubLessons(nextUnit)
        if (isSomeLessonViewed || isSomeSubLessonViewed) {
          selectedUnit = nextUnit;
        } else {
          selectedUnit = dataMenu[indexUnit]
        }
      }

      setUnitData({
        code: extractFinalNumber(selectedUnit.cod_unidad),
        name: extractUnitName(selectedUnit.nombre)
      })

    }

    setOpenLoader(false);
    getPercentage(dataMenu);
    setDataMenu(dataMenu);
    console.log(dataMenu);
  };

  const processUnitData = (data) => {
    function extractFinalNumber(cadena) {
      const match = cadena.match(/(\d+)$/); 
      if (match) {
        return parseInt(match[1], 10); 
      }
      return 0; 
    }

    function extractUnitName(titulo) {
      const match = titulo.match(/-\s*(.+)$/);
      return match ? match[1].trim() : titulo.trim();
    }

    let unitState = {
      code: 0,
      name: ""
    }
    const unitCode = data?.cod_unidad
    const unitData = dataMenu.filter(ele => ele.cod_unidad == unitCode)
    if (unitData && unitData.length > 0) {
      unitState = {
        code: extractFinalNumber(unitCode),
        name: extractUnitName(unitData[0].nombre)
      }
    }
    console.log(unitState)
    setUnitData(unitState)
  }

  const renderContent = async (type, data) => {
    console.log(type, data);
    //processUnitData(data)
    setShowUnits(false);
    setIsTestFinalize(false);
    setIsFormFinalize(false);
    setIsSublessonFinalize(false);
    if (data.cod_formulario && data.cod_formulario != "") {
      setHtmlContent(null);
      setTestData(null);
      setFormData(data);
    } else if (data.test_id && data.test_id != "") {
      setFormData(null);
      setHtmlContent(null);
      setTestData(data);
    } else {
      setFormData(null);
      setTestData(null);
      setHtmlContent({
        type: type,
        data: data,
        isExercise:
          type == "SUBLESSON" &&
          ["STEP", "LECTURA"].includes(course.tipo) &&
          data.tipo != "VOCABULARY" &&
          !["texto", "EV", "EVSU", "EVSM", "REVIEW"].includes(data.tipo),
        isReview:
          type == "LESSON" && course.tipo == "STEP" && data.tipo == "REVIEW",
        isEVSU:
          type == "LESSON" && course.tipo == "STEP" && data.tipo == "EVSU",
        isEVSM:
          type == "LESSON" && course.tipo == "STEP" && data.tipo == "EVSM",
      });
    }
  };

  const getAlias = () => {
    const key = sanitizeEmailNickname(authState.user.email)
    const savedAlias = localStorage.getItem(key);
    if (savedAlias) return savedAlias;
    return authState?.user
      ? authState?.user?.nombre_completo.split(" ")[0]
      : "Anónimo";
  };

  React.useEffect(() => {
    loadMenu();
    getAlias();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <OverlayLoader open={openLoader} />
      <AppBar position="fixed" open={open}>
        <MenuHeader
          handleDrawerOpen={handleDrawerOpen}
          open={open}
          isCourse={true}
          progress={percentage}
          courseCode={courseCode}
        />
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton
            style={{ marginRight: "50%" }}
            onClick={() => {
              navigate("/home");
            }}
          >
            <HomeIcon /> Inicio
          </IconButton>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <MenuTreeView
          data={dataMenu}
          isDisabledNext={courseCode == "LEVE"}
          onClickItem={async (type, data, nextNodeIdData) => {
            if (courseCode == "LEVE" && data.disabled) return false;
            if (nextNodeIdData) {
              setNextNodeId(nextNodeIdData);
            } else {
              setNextNodeId(null);
            }
            renderContent(type, data);
          }}
          onChangeMenu={(data) =>{
            getPercentage(data)
          }}
          isFormFinalize={isFormFinalize}
          isTestFinalize={isTestFinalize}
          isSublessonFinalize={isSublessonFinalize}
          ref={menuTreeViewRef}
        />
      </Drawer>
      <Main open={open} className="f-container fixed-hf">
        <DrawerHeader />
        <Box className="main">
          {showUnits ? (
            <div className="list-units-container">
              <Grid container columns={{ xs: 4, md: 12 }} spacing={2}>
                {units.map((card, index) => (
                  <Grid item xs={4} key={index}>
                    <ListCard
                      key={`card-${index}-${card.cod_unidad}`}
                      cardData={card}
                      onCardClick={() => {
                        menuTreeViewRef.current.setSelectedNode(
                          `UNIT-${index}-${card.cod_unidad}`
                        );
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : (
            <>
              {htmlContent &&
              !["VOCABULARY", "TEST"].includes(htmlContent.data.tipo) &&
              !htmlContent.data.cod_cuestionario &&
              !htmlContent.isExercise &&
              !htmlContent.isReview &&
              !htmlContent.isEVSU &&
              !htmlContent.isEVSM ? (
                <ContentRenderer
                  data={htmlContent.data}
                  type={htmlContent.type}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent &&
              htmlContent.data &&
              htmlContent.isExercise &&
              course.tipo == "STEP" ? (
                <ExcerciseContainer
                  courseCode={courseCode}
                  data={htmlContent.data}
                  haveContainer={false}
                  key={htmlContent.data.id}
                  configPercentage={config.porcentaje_ejercicios}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent &&
              htmlContent.data &&
              htmlContent.isExercise &&
              course.tipo == "LECTURA" ? (
                <ExerciseContainerSR
                  courseCode={courseCode}
                  data={htmlContent.data}
                  haveContainer={false}
                  key={htmlContent.data.id}
                  configPercentage={config.porcentaje_ejercicios}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent && htmlContent.data.tipo == "VOCABULARY" ? (
                <VocabularyTable
                  data={htmlContent.data}
                  type={htmlContent.type}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {formData ? (
                <FormQuestion
                  data={formData}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsFormFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isFormFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {testData && testData.test_tipo == "RADIO" ? (
                <RadioButtonTest
                  data={testData}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsTestFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isTestFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {testData && testData.test_tipo == "INPUTN" ? (
                <InputNumberTest
                  data={testData}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsTestFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isTestFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {testData && testData.test_tipo == "VF" ? (
                <TrueFalseTest
                  data={testData}
                  courseCode={courseCode}
                  onFinalize={() => {
                    setIsTestFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isTestFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent &&
              htmlContent.data &&
              (htmlContent.isReview ||
                htmlContent.isEVSU ||
                htmlContent.isEVSM) ? (
                <EvaluationReviewContainer
                  courseCode={courseCode}
                  data={htmlContent.data}
                  config={config}
                  key={"evcont-" + htmlContent.data.cod_leccion}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent && htmlContent.data.cod_cuestionario ? (
                <QuizContainer
                  courseCode={courseCode}
                  type={htmlContent.type}
                  data={htmlContent.data}
                  key={"quiz-" + htmlContent.data.cod_cuestionario}
                  configPercentage={config.porcentaje_aprobacion_cuestionarios}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
              {htmlContent &&
              htmlContent.data.tipo == "TEST" &&
              course.tipo == "LECTURA" ? (
                <TestContainer
                  courseCode={courseCode}
                  type={htmlContent.type}
                  data={htmlContent.data}
                  key={"quiz-" + htmlContent.data.cod_cuestionario}
                  configPercentage={config.porcentaje_aprobacion_cuestionarios}
                  onFinalize={() => {
                    setIsSublessonFinalize(true);
                  }}
                  onContinue={() => {
                    if (nextNodeId) {
                      menuTreeViewRef.current.setSelectedNode(
                        nextNodeId,
                        isSublessonFinalize
                      );
                    }
                  }}
                />
              ) : null}
            </>
          )}
          {hasChatWidget && chatWigetUrl.chatendpoint && chatWigetUrl.chathistory && (
            <ChatWidget
              chatWigetUrl={chatWigetUrl}
              email={authState.user.email}
              curso_id={courseCode}
              alias={getAlias()}
              botName="Asistente Virtual"
              welcomeMessage="¡Hola! Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?"
              unitData={unitData}
            />
          )}
        </Box>

        <Box className="footer">
          <MenuFooter
            open={open}
            isCourse={true}
            courseCode={courseCode}
            course={course}
            unitData={unitData}
            legalPage={legalPage}
            website={website}
            botonComunidad={botonComunidad}
            botonGames={botonGames}
          />
        </Box>
      </Main>
      {/*<ToastContainer limit={3} autoClose={3000} />*/}
    </Box>
  );
}
